module.exports = __webpack_public_path__ + "img/text.5472ae4f.png";